<script>
import { loadAssetWhiteLabel } from '@composables/utils/loadAsset'
import { appImg } from 'tb-design_system-web'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import RegisterLayout from '@/components/shared/registerLayout.vue'
import { validateStepAccess } from '@/composables/utils/onboardingGuards'
import { useOnboardingStore } from '@/stores/onboarding'

export default {
  name: 'RegisterSuccess',
  components: {
    RegisterLayout,
    appImg
  },
  setup() {
    const router = useRouter()
    const onboardingStore = useOnboardingStore()

    const email = ref('')
    const isPJ = onboardingStore.typeClient === 'PJ'

    const verificationImg = new URL('@/assets/img/svg/verification.svg', import.meta.url).href

    onMounted(() => {
      const requiredType = isPJ ? 'PJ' : 'PF'
      const requiredSteps = isPJ ? [1, 2, 3] : [1, 2]

      validateStepAccess(onboardingStore, requiredType, requiredSteps, router)

      email.value = onboardingStore.getStepData(isPJ ? 2 : 1)?.email || ''
      onboardingStore.resetState()
    })

    return {
      email,
      verificationImg,
      loadAssetWhiteLabel
    }
  }
}
</script>

<template>
  <RegisterLayout>
    <div class="col-12 col-md-9 d-flex align-items-center">
      <div class="w-100">
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-md-6 col-lg-5 d-flex flex-column align-items-center">
            <app-img
              class="img-responsive mb-5"
              :src="loadAssetWhiteLabel('logo.svg')"
              alt="logo"
              height="30"
            />

            <div class="col-12 d-flex justify-content-center mb-3">
              <img :src="verificationImg" width="140" height="140" />
            </div>

            <div class="col-12 text-center">
              <h4 class="text-center mb-4">
                <b>Valide seu endereço de e-mail para confirmar sua identidade</b>
              </h4>

              <p class="box p-2">
                E-mail enviado para <b>{{ email }}</b>
              </p>

              <small>
                Caso não encontre o e-mail na sua caixa de entrada, verifique a sua caixa de SPAM
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </RegisterLayout>
</template>

<style scoped lang="scss">
.box {
  border-radius: 9px;
  background-color: #140617;
  color: #ffffff;
}
</style>
